export default {
  g_network_reachable: '已重新連上網路',
  g_network_unreachable: '沒有網路連線',
}
